export default "__VITE_ASSET__DBZY3fDc__"